import React, {FC, HTMLAttributes} from "react"
import styled from "styled-components"


const StyledFlexDiv = styled.div`
    display: flex;
    flex: calc(100% - 35px);
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    @media screen and (min-width: 600px) {
        flex: calc(50% - 35px);
    }
`;

const FlexTwoCol: FC<HTMLAttributes<HTMLDivElement>> = (props) => <StyledFlexDiv {...props} />

export default FlexTwoCol